module.exports = __webpack_public_path__ + "static/media/TrierweilerCreates-nrm-OngBlk.da915d1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/TrierweilerCreates-nrm-OngBlk.png
// module id = 19
// module chunks = 0